// src/stone/icons/HandShake2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var HandShake2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "m18.922 9.159-7.485 7.485a5.667 5.667 0 0 0 7.57-.398l4.326-4.327 1.415 1.414-4.327 4.327a7.667 7.667 0 0 1-10.841 0l-.994-.993 8.922-8.922a12.787 12.787 0 0 1 20.017 15.601l-.512.859-1.718-1.026.513-.858a10.79 10.79 0 0 0-1.633-13.162 10.787 10.787 0 0 0-15.253 0" }),
      /* @__PURE__ */ jsx("path", { d: "m14.342 5.991-1 .009a10.75 10.75 0 0 0-7.516 3.158l-.708-.706.708.707a10.787 10.787 0 0 0 0 15.252l9.476 9.477a9 9 0 0 0 12.73 0l2.726-2.727a4 4 0 0 0 0-5.656l-6.729-6.728 1.414-1.415 6.73 6.73a6 6 0 0 1 0 8.483l-2.728 2.727a11 11 0 0 1-15.557 0L4.41 25.825A12.787 12.787 0 0 1 13.325 4l1-.009z" }),
      /* @__PURE__ */ jsx("path", { d: "m24.874 25.491 6.485 6.483-1.414 1.415-6.485-6.484zM20.512 29.851l6.05 6.05-1.414 1.414-6.05-6.05z" })
    ]
  }
);
var HandShake2X_default = HandShake2X;

export {
  HandShake2X_default
};
